import React from "react"
import PropTypes from "prop-types"
import "./hero.scss"

export default function HeroImgL({
  children,
  image,
  alt,
  buttonText,
  buttonLink,
}) {
  return (
    <div className="heroil">
      <div className="heroil__container">
        <div className="heroil__container--left">
          <img
            className="heroil__container--img"
            src={image}
            placeholder="blurred"
            alt={alt}
          />
        </div>
        <div className="heroil__container--right">
          {children}
          <div id="btn-container">
            <button className="hero__container--btn inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-pink-700 bg-pink-100 hover:bg-pink-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
              <a href={buttonLink}>{buttonText}</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

HeroImgL.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string,
  children: PropTypes.node.isRequired,
}
